export const INPUT = {
    INPUT_EVENT_DELAY_SHORT:                               300,
    INPUT_EVENT_DELAY:                                     500,
    INPUT_EVENT_DELAY_LONG:                                1500,
    POLLING_MS_SHORT:                                      1500,    // 1.5s
    POLLING_MS:                                            20000,   // 20s
    POLLING_MS_LONG:                                       120000,  // 2min
    INACTIVE_DELAY:                                        2000,
    MINIMUM_REQUIRED_CHARACTERS_SHORT:                     3,
    MINIMUM_REQUIRED_CHARACTERS_LONG:                      12,
    MINIMUM_REQUIRED_UNBLOCKED_TRANSACTION_TIME_SHORT:     500,
    MINIMUM_REQUIRED_UNBLOCKED_TRANSACTION_TIME_LONG:      1000,
    MINIMUM_REQUIRED_UNBLOCKED_TRANSACTION_TIME_VERY_LONG: 2000,
};

export const DISPLAY = {
    EFFECT_SHORT:        150,
    EFFECT:              350,
    FADE:                350,
    TRANSITION_DELAY:    2000,
    ANIMATION_DELAY:     450,
    WAIT_QUARTER_SECOND: 250,
    WAIT_HALF_SECOND:    500,
    WAIT_ONE_SECOND:     1000,
    WAIT_VERY_SHORT:     1500,
    WAIT_SHORT:          3000,
    WAIT_LONG:           6500,
};

export const PAGE = {
    BREADCRUMB_HEIGHT:  40,
    STICKY_CONTENT_TOP: 80,
}

export enum UI_DISPLAY_MODES {
    CHROME_MINIMIZED              = 'chrome-minimized',
    ROADMAP_MINIMIZED             = 'roadmap-minimized',
    ACTIVITY_MAP_MINIMIZED        = 'activity-map-minimized',
    BUDGET_BY_DASHBOARD_MINIMIZED = 'budget-by-dashboard-minimized',
    BUDGET_BY_HIRE_MINIMIZED      = 'budget-by-hire-minimized',
}
